import { ServiceVanEffects } from './effects';

export * as ServiceVanActions from './actions';
export * as ServiceVanReducer from './reducer';
export * as ServiceVanSelectors from './selectors';
export const SERVICEVAN_EFFECTS: any[] = [ServiceVanEffects];
